export const handleError = (error) => {
    console.error('Error:', error);
}  